import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { paymentApi } from '../services/api';
import { Check, Xmark } from 'iconoir-react';
import '../styles/payment.css';

export const PaymentCallbackPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('Vérification du paiement en cours...');

  useEffect(() => {
    verifyPayment();
  }, []);

  const verifyPayment = async () => {
    let paymentId = searchParams.get('payment_id');

    // Fallback : si Stancer n'a pas relayé payment_id, on récupère le dernier
    // paiement en attente pour cet utilisateur depuis la DB.
    if (!paymentId) {
      try {
        const fallback = await paymentApi.getLastPendingId();
        paymentId = fallback.data.payment_id;
      } catch {
        setStatus('error');
        setMessage('Identifiant de paiement manquant');
        return;
      }
    }

    try {
      const response = await paymentApi.getPaymentStatus(paymentId);
      const paymentStatus = response.data.payment.status;

      if (paymentStatus === 'captured' || paymentStatus === 'authorized' || paymentStatus === 'to_capture') {
        setStatus('success');
        setMessage('Paiement confirmé ! Redirection vers votre compte...');
        
        // Redirect to dashboard after 2 seconds
        setTimeout(() => {
          navigate('/dashboard');
        }, 2000);
      } else if (paymentStatus === 'failed' || paymentStatus === 'refused') {
        setStatus('error');
        setMessage('Le paiement a échoué. Veuillez réessayer.');
      } else {
        setStatus('loading');
        setMessage('Paiement en cours de traitement...');
        
        // Retry after 3 seconds
        setTimeout(() => {
          verifyPayment();
        }, 3000);
      }
    } catch (error: any) {
      console.error('Erreur lors de la vérification du paiement:', error);
      setStatus('error');
      setMessage('Erreur lors de la vérification du paiement');
    }
  };

  return (
    <div className="payment-callback-page">
      <div className="payment-callback-container">
        {status === 'loading' && (
          <div className="payment-callback-content">
            <div className="spinner"></div>
            <h2>Vérification en cours</h2>
            <p>{message}</p>
          </div>
        )}

        {status === 'success' && (
          <div className="payment-callback-content success">
            <div className="icon-circle success">
              <Check width={48} height={48} strokeWidth={2} />
            </div>
            <h2>Paiement réussi</h2>
            <p>{message}</p>
          </div>
        )}

        {status === 'error' && (
          <div className="payment-callback-content error">
            <div className="icon-circle error">
              <Xmark width={48} height={48} strokeWidth={2} />
            </div>
            <h2>Paiement échoué</h2>
            <p>{message}</p>
            <button 
              className="btn btn-primary"
              onClick={() => navigate('/register')}
            >
              Retour à l'inscription
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
